import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://gpccynmhjeaymttirypc.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdwY2N5bm1oamVheW10dGlyeXBjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODc0NzQzNjAsImV4cCI6MjEwMzA1MDM2MH0.SBVjOPqjZVT5W2mquWvnxa9v_JTRB2uLjf7P-c20OUk';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
